import { useEffect, useRef } from 'react';

const CALENDLY_URL = "https://calendly.com/maximilian-gastro-beratung/30min?hide_event_type_details=1&hide_gdpr_banner=1&background_color=4b1f82&text_color=f2eee6&primary_color=cbb7ee";

/**
 * Calendly Inline Widget Component
 * Embeds the Calendly booking widget directly in the page
 */
export const CalendlyInline = ({ height = 700, className = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Re-initialize Calendly widget when component mounts
    if (window.Calendly && containerRef.current) {
      window.Calendly.initInlineWidget({
        url: CALENDLY_URL,
        parentElement: containerRef.current,
      });
    }
  }, []);

  return (
    <div 
      ref={containerRef}
      className={`calendly-inline-widget ${className}`}
      data-url={CALENDLY_URL}
      style={{ minWidth: '320px', height: `${height}px` }}
    />
  );
};

/**
 * Calendly Popup Button Component
 * Opens Calendly in a popup modal when clicked
 */
export const CalendlyButton = ({ 
  children, 
  className = "",
  prefill = {}
}) => {
  const handleClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: CALENDLY_URL,
        prefill: prefill
      });
    }
  };

  return (
    <button 
      onClick={handleClick}
      className={className}
      type="button"
    >
      {children}
    </button>
  );
};

/**
 * Hook to open Calendly popup programmatically
 */
export const useCalendly = () => {
  const openCalendly = (prefill = {}) => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: CALENDLY_URL,
        prefill: prefill
      });
    }
  };

  return { openCalendly };
};

export default CalendlyInline;
